// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tTYx","productName":"Table_productName__2pPZi"};